import React from 'react';
/* eslint-disable jsx-a11y/no-autofocus -- custom Modal prop focuses through react-focus-lock. */
import { FormattedMessage } from 'react-intl';

import { bgNegative, bgPrimary } from '@osmosis/tailwind-ui/styles/background';
import { text0 } from '@osmosis/tailwind-ui/styles/text';
import { Box } from '@osmosis/tailwind-ui/components/Box';
import { Button } from '@osmosis/tailwind-ui/components/Button';
import { H3 } from '@osmosis/tailwind-ui/components/Text';
import { P } from '@osmosis/tailwind-ui/components/Text';

import Modal, { ModalProps } from './Modal';
import ActionBar from './ModalFooter';

type ConfirmationDialogProps = ModalProps & {
  error?: boolean;
  dialogHeader?: string;
  dialogMessage?: string;
};

/**
 * Dialog for confirming user feedback.
 * @param props ModalProps and error flag.
 * @returns Void.
 */
const ConfirmationDialog = ({
  error = false,
  dialogHeader,
  dialogMessage,
  ...modalProps
}: ConfirmationDialogProps) => {
  return (
    <Modal {...modalProps} autoFocus className="min-w-[300px] md:min-w-[500px]">
      <Box className={`p-3 ${error ? bgNegative : bgPrimary}`}>
        <H3 className={text0}>{dialogHeader}</H3>
      </Box>
      <Box className="p-4">
        <P>{dialogMessage}</P>
      </Box>
      <ActionBar centreButtons={false}>
        <Button
          data-testid="confirmation-dialog-button"
          variant="outline"
          onClick={modalProps.hide}
        >
          <FormattedMessage defaultMessage="OK" id="common.ok" />
        </Button>
      </ActionBar>
    </Modal>
  );
};

export default ConfirmationDialog;
